import styled, { css } from 'styled-components';
import { InputGroup } from 'core/form';

const SearchInput = styled(InputGroup)`
  width: 100%;

  &.bp4-input-group > .bp4-input-left-container > .bp4-icon {
    margin: 8px;
  }

  &.bp4-input-group > .bp4-icon:first-child {
    left: 4px;
  }

  &.bp4-input-group .bp4-input:not(:first-child) {
    padding-left: 36px;
  }

  // keyboard shortcut positioning
  &.bp4-input-group .bp4-input-action {
    top: 9px;
    right: 14px;
    font-size: 11px;
  }

  input {
    border-radius: 32px;
    height: 32px;
    background: ${({ theme }) => (theme.name === 'dark' ? '#4A4A4A' : '#2D3D52')};
    color: #ffffff;
    border-color: rgba(255, 255, 255, 0.1);
    transition: all 300ms cubic-bezier(0.33, 1, 0.68, 1);
    ::placeholder {
      color: ${({ theme }) => (theme.name === 'dark' ? '#A0A0A0' : '#9AA3AD')};
    }

    &.bp4-input:focus,
    .bp4-input.bp4-active {
      box-shadow:
        0 0 0 1px #157ff3,
        0 0 0 3px rgba(21, 127, 243, 0.3),
        inset 0 1px 1px rgba(16, 22, 26, 0.2);
    }

    ${({ $isOpen }) =>
      $isOpen &&
      css`
        box-shadow:
          0 0 0 2px #157ff3,
          0 0 0 4px rgba(21, 127, 243, 0.3);
      `}
  }

  svg {
    fill: #e3e3e3;
  }
`;

export default SearchInput;
